import {
  ColScaffold,
  EMPTY_SCAFFOLD_SELECTION,
  RowScaffold,
  ScaffoldSelection,
} from "../../interface";
import { buildCellRange } from "./buildCellRange";

/**
 * Replaces the current selection with a rectangular cell range between two cells.
 *
 * @param rows - All available scaffold rows.
 * @param cols - All available scaffold columns.
 * @param anchorRowId - The row ID of the selection anchor.
 * @param anchorColId - The column ID of the selection anchor.
 * @param targetRowId - The row ID of the selection target.
 * @param targetColId - The column ID of the selection target.
 * @returns A new selection state containing only the cell range.
 */
export const setCellRangeSelection = <T>(
  rows: RowScaffold<T>[],
  cols: ColScaffold<T>[],
  anchorRowId: string,
  anchorColId: string,
  targetRowId: string,
  targetColId: string,
): ScaffoldSelection => ({
  ...EMPTY_SCAFFOLD_SELECTION,
  selectedCells: buildCellRange(rows, cols, anchorRowId, anchorColId, targetRowId, targetColId),
});
